var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contents-inner" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("p", {
        staticClass: "mt20 pega-pre-wrap",
        attrs: { "data-test": "process" },
        domProps: { textContent: _vm._s(_vm.selection.selectionProcess) },
      }),
      _vm._v(" "),
      _vm._l([1, 2, 3], function (index) {
        return [
          _vm.isShow.interview(index)
            ? [
                _c(
                  "p",
                  {
                    key: "title-" + index,
                    staticClass: "hd-type-0n3",
                    attrs: { "data-test": "title-" + index },
                  },
                  [
                    _c("span", [
                      _vm._v("面接会場" + _vm._s(index !== 1 ? index : "")),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    key: "body-" + index,
                    staticClass: "mt20",
                    attrs: { "data-test": "body-" + index },
                  },
                  [
                    _vm.selection["zipCode" + index]
                      ? [
                          _vm._v(
                            "\n          〒 " +
                              _vm._s(_vm.selection["zipCode" + index])
                          ),
                          _c("br"),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selection["address" + index]
                      ? _c("span", {
                          staticClass: "pega-pre-wrap",
                          attrs: { "data-test": "address-" + index },
                          domProps: {
                            textContent: _vm._s(
                              _vm.selection["address" + index] + "\n"
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selection["placeMapAddress" + index]
                      ? [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "" +
                                  _vm.googleMapURL +
                                  _vm.selection["placeMapAddress" + index],
                                target: "_blank",
                                "data-test": "map-" + index,
                              },
                            },
                            [_vm._v("[map]")]
                          ),
                          _c("br"),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selection["personInCharge" + index]
                      ? [
                          _vm._v(
                            "\n          担当者 ／ " +
                              _vm._s(_vm.selection["personInCharge" + index])
                          ),
                          _c("br"),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selection["tel" + index]
                      ? [
                          _vm._v(
                            "\n          Tel ／ " +
                              _vm._s(_vm.selection["tel" + index]) +
                              "\n        "
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt20", attrs: { "data-test": "inquiry" } },
        [
          _vm.companyName
            ? [_vm._v("\n      " + _vm._s(_vm.companyName)), _c("br")]
            : _vm._e(),
          _vm._v(" "),
          _vm.selection.inquiryUrl
            ? [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.selection.inquiryUrl,
                      target: "_blank",
                      rel: "nofollow",
                      "data-test": "inquiryUrl",
                    },
                  },
                  [_vm._v(_vm._s(_vm.selection.inquiryUrl))]
                ),
                _c("br"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.selection.inquiryZip
            ? [
                _vm._v("\n      〒 " + _vm._s(_vm.selection.inquiryZip)),
                _c("br"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.selection.inquiryAddress
            ? [
                _c("span", {
                  staticClass: "pega-pre-wrap",
                  attrs: { "data-test": "address" },
                  domProps: {
                    textContent: _vm._s(_vm.selection.inquiryAddress),
                  },
                }),
                _c("br"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.selection.inquiryPerson
            ? [
                _vm._v(
                  "\n      担当者 ／ " + _vm._s(_vm.selection.inquiryPerson)
                ),
                _c("br"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.selection.inquiryTel
            ? [
                _vm._v("\n      Tel ／ " + _vm._s(_vm.selection.inquiryTel)),
                _c("br"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.selection.inquiryEmail
            ? [
                _vm._v(
                  "\n      E-mail ／ " +
                    _vm._s(_vm.selection.inquiryEmail) +
                    "\n    "
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isShow.links
        ? [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "mt20", attrs: { "data-test": "link-body" } },
              [
                _vm._l([1, 2, 3], function (index) {
                  return [
                    _vm.selection["companyLinkNm" + index]
                      ? [
                          _c(
                            "a",
                            {
                              key: "link-" + index,
                              attrs: {
                                href: _vm.selection["companyLinkUrl" + index],
                                target: "_blank",
                                rel: "nofollow",
                                "data-test": "link-" + index,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.selection["companyLinkNm" + index])
                              ),
                            ]
                          ),
                          _c("br", { key: "br-" + index }),
                        ]
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("選考プロセス")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "hd-type-0n3" }, [
      _c("span", [_vm._v("問い合わせ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "link-title" } },
      [_c("span", [_vm._v("関連リンク")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }